import type { IconProps } from '../types/IconProps.ts';
export const Target: IconProps = {
    name: 'Target',
    children: [
        `<circle cx="12" cy="12" r="10" />`,
        `<circle cx="12" cy="12" r="6" />`,
        `<circle cx="12" cy="12" r="2" />`,
    ]
};